import FW from './fw';
import Logger from './logger';


export default class LocalStorage {

  static available(allow) {
    if (!allow) {
      return false;
    }
    if (window.localStorage) {
      try {
        const x = '__storage_test__';
        localStorage.setItem(x, x);
        localStorage.removeItem(x);
        return true;
      } catch (warning) {
        console.warn(warning);
        return false;
      }
    }
    return false;
  }

  static writeCurrentTime(currentTime, id) {
    const rmpCurrentTime = { value: (Math.round(currentTime)).toString() };
    const validatedID = id || 'default';
    try {
      localStorage.setItem('rmpCurrentTime-' + validatedID, JSON.stringify(rmpCurrentTime));
      Logger.print('local-storage', 'wrote current time ' + currentTime + ' ms');
    } catch (warning) {
      console.warn(warning);
    }
  }

  static writeQuality(quality) {
    const rmpQuality = { value: (Math.round(quality)).toString() };
    try {
      localStorage.setItem('rmpQuality', JSON.stringify(rmpQuality));
      Logger.print('local-storage', 'wrote quality ' + quality);
    } catch (warning) {
      console.warn(warning);
    }
  }

  static writeVolume(inputVolume) {
    let validatedVolume = inputVolume;
    validatedVolume = FW.precisionRound(validatedVolume, 2);
    const rmpVolume = { value: validatedVolume.toString() };
    try {
      localStorage.setItem('rmpVolume', JSON.stringify(rmpVolume));
      Logger.print('local-storage', 'wrote volume ' + validatedVolume);
    } catch (warning) {
      console.warn(warning);
    }
  }

} 
